import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Stack,
  Fade,
  Backdrop,
} from "@mui/material";

const VerifySwitchRoleModal = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  description = "Are you sure you want to continue?",
  confirmText = "Yes, Continue",
  cancelText = "Cancel",
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 4,
            width: "90%",
            maxWidth: 680,
          }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            {description}
          </Typography>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button onClick={onClose} variant="outlined">
              {cancelText}
            </Button>
            <Button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              variant="contained"
              sx={{
                backgroundColor: "#F5B800",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "#d49f00" },
              }}
            >
              {confirmText}
            </Button>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  );
};

export default VerifySwitchRoleModal;
